export default __webpack_public_path__ + "static/media/accumulator.f1959df0.png";